import React from 'react';
import ColorPicker from '../../statefullComponents/ColorPicker/ColorPicker.jsx'

const component_name = (props) => {
  // component logic
  const colorList = [];
  // loop over color object
  for (const prop in props.data) {
    colorList.push([prop,props.data[prop]]);
  }
  let colorListOutput = (
    <div>
      {colorList.map((color, index) => {
        return <ColorPicker 
        key={index} 
        name={color[0]}
        color={color[1]}
        onChange={(event) => props.onChange(event, color[0])}/>
      })}
    </div>
  )
 
  // execute the return function/method
  return (
    <div className='component_name'>
      {colorListOutput}
      <div>
        <label htmlFor="">backgroundImage</label><br/>
        <input type="text" onChange={(event) => props.backgroundImage(event)}/>
      </div>
    </div>
);
};

export default component_name;